import React from "react";
import Typography from "@mui/material/Typography";
import { Avatar, Chip, Grow, Tooltip } from "@mui/material";
import Box from "@mui/material/Box";
import { parseFloatToFixed } from "../../../../extras";
import { useDispatch } from "react-redux";
import { setItem } from "../../../../store/actions/newOrderSlice";
import { v4 as uuidv4 } from "uuid";
import { formatFinance } from "../../../../utils/formatters";
import CardMediaWithFallback from "./CardMediaWithFallback";
import { Windows11Card } from "../../../styled/pos/windows11";
import { blue } from "@mui/material/colors";

const ProductCard = ({ product }) => {
  const dispatch = useDispatch();

  const { title, price } = product;
  const isIfoodImported = Boolean(product.is_ifood_imported);

  const selectProduct = () => {
    dispatch(setItem({ ...product, product_identifier: uuidv4() }));
  };

  return (
    <Grow
      in={true}
      style={{ transformOrigin: "0 0 0" }}
      {...{ timeout: 1000 * (1 / 5) }}
    >
      <Windows11Card
        onClick={selectProduct}
        sx={{
          p: 2,
          height: "100%",
          display: "flex",
          flexDirection: "column",
          position: "relative",
        }}
      >
        {/* iFood imported badge */}
        {isIfoodImported && (
          <Tooltip title="Produto importado do iFood">
            <Avatar
              src="/images/logo-ifood.png"
              alt="iFood"
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                width: 24,
                height: 24,
                borderRadius: 100,
                boxShadow: 1,
                bgcolor: "common.white",
              }}
            />
          </Tooltip>
        )}

        {/* Image Container */}
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            mb: 2,
          }}
        >
          <Box sx={{ width: 100, height: 100 }}>
            <CardMediaWithFallback
              image="https://images.immediate.co.uk/production/volatile/sites/30/2020/08/chorizo-mozarella-gnocchi-bake-cropped-9ab73a3.jpg"
              alt={title}
            />
          </Box>
        </Box>

        {/* Price Chip */}
        <Chip
          label={formatFinance(parseFloatToFixed(price))}
          size="small"
          sx={{
            mb: 2,
            width: "100%",
            bgcolor: blue[50],
            color: blue[700],
            fontWeight: 600,
            borderRadius: 1.5, // 6px
            border: `1px solid ${blue[100]}`,
          }}
        />

        {/* Title (pushed to bottom with flexGrow) */}
        <Box sx={{ mt: "auto" }}>
          <Typography
            component="div"
            variant="body1"
            align="center"
            sx={{
              fontWeight: 600,
              lineHeight: 1.3,
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
            }}
          >
            {title}
          </Typography>
        </Box>
      </Windows11Card>
    </Grow>
  );
};

export default ProductCard;
